import { Link } from "react-router-dom";
import AppMenu from "./AppMenu";
import { MenuProvider } from "./context/menucontext";

const AppSidebar = () => {
    return (
        <>
            <Link to="/" className="app-logo">
                <img src={`${process.env.PUBLIC_URL}/img/WiseConn500.png`} alt="wiseconn-logo" />
            </Link>

            <div className="layout-menu-container">
                <MenuProvider>
                    <AppMenu />
                </MenuProvider>
            </div>
        </>
    );
};

export default AppSidebar;
